import { createContext, useContext, useState } from "react";
import { useScrollTo } from "./SmoothScroll";

const Ctx = createContext({ experience: "sintra", setExperience: () => {}, choose: () => {} });

export const BookingProvider = ({ children }) => {
  const [experience, setExperience] = useState("sintra");
  const go = useScrollTo();
  const choose = (id) => {
    setExperience(id);
    go("#reservar");
  };
  return <Ctx.Provider value={{ experience, setExperience, choose }}>{children}</Ctx.Provider>;
};

export const useBooking = () => useContext(Ctx);
